import { useState, useEffect } from 'react';
import { supabaseGetter } from '~/api/supabase-getter';

/**
 * Hook to fetch crop archetypes
 * @returns {Object} Crop archetypes, loading state, and error
 */
export const useCropArchetypes = () => {
  const [cropArchetypes, setCropArchetypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError(null);

      try {
        const { data: cropArchetypeData, error: cropArchetypeError } =
          await supabaseGetter.cropArchetypes.getAll();

        if (cropArchetypeError) throw cropArchetypeError;

        setCropArchetypes(cropArchetypeData || null);
      } catch (err) {
        console.error('Error fetching crop archetypes data:', err);
        setError(err.message);
        setCropArchetypes([]);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  return {
    cropArchetypes,
    loading,
    error,
    invalidate: () => {
      supabaseGetter.cropArchetypes.invalidate();
    }
  };
}
